import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollDeleteCustomFieldResponse } from '../types';

type PayrollDeleteCustomFieldRequest = {
  fieldKey: string;
};

export const deleteCustomFieldMutation = gql`
  mutation PayrollDeleteCustomField($fieldKey: String!) {
    payrollDeleteCustomField(fieldKey: $fieldKey)
  }
`;

export const deleteCustomField = (queryVariables: PayrollDeleteCustomFieldRequest) =>
  graphQLApi<PayrollDeleteCustomFieldResponse, PayrollDeleteCustomFieldRequest>({
    query: deleteCustomFieldMutation,
    queryVariables,
  });
